module.exports = __webpack_public_path__ + "static/Unilever-DSEP-ClassroomActivity-Virtual-2.3-Media-WhatsTheInfluence_FR-1c7770e7f3a611985ec89fef57a75fdd.pdf";